import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { environment } from '../../../environments/environment';

@Injectable()
export class AuthLoginService {
  constructor() {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const url = state.url;
    if (url.indexOf('/login') > -1) {
      return this.allowLogin();
    }
    return true;
  }

  allowLogin(): boolean {
    if (environment.ft.enableLogin) {
      return true;
    }
    console.warn('Login has been disabled');
    window.location.replace(`${environment.servicesPlatform}/login?sid=${environment.SERVICE_ID}`);
    return false;
  }
}
